<template>
  <div class="modal" v-if="visible">
    <div class="modal-position modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5>가이드</h5>
          <button type="button" class="close" @click="clickCloseModal">×</button>
        </div>
        <div class="modal-body">
          <div class="h-500px scroll">
            <img class="w-100per" src="../assets/images/codeGuide.png" alt="코드가이드" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, watch } from '@vue/runtime-core';
import _ from 'lodash';
export default {
  props: {
    visible: {
      type: Boolean,
      required: false,
      default: false,
    },
    list: {
      type: Object,
      required: false,
      default() {
        return [];
      },
    },
  },
  emits: ['closeModal'],
  setup(props, cotext) {
    const clickCloseModal = () => {
      cotext.emit('closeModal');
    };

    watch(
      () => props.visible,
      cur => {
        if (cur) {
        }
      }
    );

    onMounted(() => {});

    return {
      clickCloseModal,
    };
  },
};
</script>

<style lang="scss">
.scroll {
  overflow-y: scroll;
}
</style>
